import React, {useCallback} from "react";
import TemporaryContent from "../TemporaryContent";
import { InlineNotification } from '../Notification';
import { Spinner } from "../../../useOss";
import { ApiKeyRequestStatus } from "../../../dashboard/saas/types";

export type ApiKeyActionProps = {
  status?: ApiKeyRequestStatus,
  errorMessage?: string;
  onClick?: () => void
}

const CreateApiKeyClickButton: React.FC<{onClick?: Function}> = ({onClick}) => {
  const onButtonClick = useCallback((event: Pick<Event, "preventDefault">) => {
    event.preventDefault();
    if (onClick !== undefined) { onClick(); }
  }, [onClick])
  return <div><a className="db-button" onClick={onButtonClick} href="">+ Create new API key</a></div>
}

export const CreateApiKeyButton: React.FC<ApiKeyActionProps> = ({ status, onClick, errorMessage } = {}) => {   
  return <>
    {status === "error" && <InlineNotification duration={5000} status="error" autoDisappear={true}>{errorMessage || "Failed to create an API key. Please try again."}</InlineNotification>}
    {status === "success" && <TemporaryContent autoDismiss={false} contentAfterDisappear={<CreateApiKeyClickButton onClick={onClick} />}>
      <InlineNotification status="success">API key created successfully.</InlineNotification>
    </TemporaryContent>}
    {(status == undefined || status === "error") && <CreateApiKeyClickButton onClick={onClick} />}
    {status === "loading" &&  <div className="create-loading"><span>Creating API key</span><Spinner isInline={true}/></div>}
  </>
}

export default CreateApiKeyButton;
